import { render, staticRenderFns } from "./CertificationCallout.vue?vue&type=template&id=7fab2130&"
import script from "./CertificationCallout.vue?vue&type=script&lang=js&"
export * from "./CertificationCallout.vue?vue&type=script&lang=js&"
import style0 from "./CertificationCallout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports